<div class="step-services">
  <div class="step-header">
    <div>
      <h3>Geração de Pedidos</h3>
      <p class="step-subtitle">
        Itens elegíveis para faturamento no período de
        <strong>{{ process.referenceMonth }}/{{ process.referenceYear }}</strong>.
        Use o botão <em>Personalizar</em> em cada categoria para refinar a seleção.
      </p>
    </div>
    <button pButton type="button" class="easymarine secondary"
      icon="pi pi-refresh" label="Recarregar elegíveis"
      [disabled]="loading" (click)="reload()"></button>
  </div>

  <div class="summary-cards">
    <div *ngFor="let s of summaries" class="summary-card" [class.empty]="s.available === 0">
      <div class="summary-card-header">
        <i [class]="s.icon"></i>
        <span class="summary-card-title">{{ s.title }}</span>
      </div>

      <div class="summary-card-body">
        <div class="summary-row">
          <span class="summary-row-label">Disponíveis</span>
          <span class="summary-row-value">{{ s.available }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-row-label">Total disponível</span>
          <span class="summary-row-value money">
            {{ s.totalAvailable | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
          </span>
        </div>
        <div class="summary-row selected">
          <span class="summary-row-label">Selecionados</span>
          <span class="summary-row-value">{{ s.selected }}</span>
        </div>
        <div class="summary-row selected">
          <span class="summary-row-label">Total selecionado</span>
          <span class="summary-row-value money">
            {{ s.totalSelected | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
          </span>
        </div>
        <div class="summary-row warn" *ngIf="s.skipped > 0">
          <span class="summary-row-label">Não-elegíveis</span>
          <span class="summary-row-value">{{ s.skipped }}</span>
        </div>
      </div>

      <div class="summary-card-actions">
        <button pButton type="button" class="easymarine secondary"
          icon="pi pi-sliders-h" label="Personalizar"
          [disabled]="s.available === 0"
          (click)="openPersonalize(s.key)"></button>
      </div>
    </div>
  </div>

  <div *ngIf="!loading && items.length === 0" class="empty-state">
    <i class="pi pi-inbox"></i>
    <h4>Nenhum item elegível</h4>
    <p>
      Não há itens elegíveis para o período selecionado.
      Verifique contratos vigentes e processos já gerados.
    </p>
  </div>

  <div class="grand-summary" *ngIf="items.length > 0">
    <div class="grand-summary-item">
      <span class="grand-summary-label">Disponíveis (total)</span>
      <span class="grand-summary-value">
        {{ countGrandAvailable }} itens —
        <span class="money">{{ totalGrandAvailable | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</span>
      </span>
    </div>
    <div class="grand-summary-item">
      <span class="grand-summary-label">Selecionados (total)</span>
      <span class="grand-summary-value">
        {{ countGrandSelected }} itens —
        <span class="money">{{ totalGrandSelected | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</span>
      </span>
    </div>
    <div class="grand-summary-item warn" *ngIf="countGrandSkipped > 0">
      <span class="grand-summary-label">Não-elegíveis</span>
      <span class="grand-summary-value">{{ countGrandSkipped }} itens</span>
    </div>
  </div>

  <div class="step-actions">
    <button pButton type="button" class="easymarine primary"
      icon="pi pi-arrow-right" iconPos="right" label="Próximo"
      [disabled]="loading || countGrandSelected === 0" (click)="next.emit()"></button>
  </div>

  <p-dialog
    [(visible)]="personalizeOpen"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '1200px', maxWidth: '95vw' }"
    [header]="personalizeTitle"
    (onHide)="closePersonalize()">

    <div class="personalize-content">
    <div class="personalize-toolbar">
      <button pButton type="button" class="easymarine secondary"
        icon="pi pi-check-square" label="Marcar todos"
        (click)="personalizeOpen && toggleAll(personalizeOpen, true)"></button>
      <button pButton type="button" class="easymarine secondary"
        icon="pi pi-stop" label="Desmarcar todos"
        (click)="personalizeOpen && toggleAll(personalizeOpen, false)"></button>
      <span class="p-input-icon-left personalize-search">
        <i class="pi pi-search"></i>
        <input pInputText type="text" placeholder="Buscar por cliente ou embarcação"
          (input)="personalizeTable.filterGlobal($any($event.target).value, 'contains')" />
      </span>
    </div>

    <div class="personalize-filters">
      <label class="filter-checkbox">
        <p-checkbox [binary]="true" [(ngModel)]="showOnlyEligible"></p-checkbox>
        <span>Exibir somente elegíveis</span>
      </label>
      <p-multiSelect
        [options]="productOptions"
        [(ngModel)]="selectedProductFilter"
        optionLabel="label" optionValue="value"
        placeholder="Filtrar por serviço"
        selectedItemsLabel="{0} serviços selecionados"
        [maxSelectedLabels]="2"
        [filter]="true" filterPlaceHolder="Buscar serviço"
        styleClass="filter-product"
        appendTo="body">
      </p-multiSelect>
    </div>

    <p-table #personalizeTable [value]="personalizeItems"
      [paginator]="personalizeItems.length > 100"
      [rows]="100" [rowsPerPageOptions]="[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]"
      [globalFilterFields]="['boatName', 'productName', 'customers.0.customerName', 'customers.1.customerName', 'customers.2.customerName']"
      styleClass="p-datatable-sm personalize-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 60px">Sel.</th>
          <th style="width: 28%">Embarcação</th>
          <th>Cliente(s)</th>
          <th style="width: 28%">Serviço</th>
          <th style="width: 150px; text-align: right">Valor</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr [class.row-skipped]="isLocked(item)" [class.row-selected]="item.selected && !isLocked(item)">
          <td>
            <p-checkbox [binary]="true" [ngModel]="item.selected"
              (onChange)="toggle(item)"
              [disabled]="isLocked(item)"></p-checkbox>
          </td>
          <td>
            <div class="cell-boat">
              <span class="boat-name">{{ item.boatName || '—' }}</span>
              <span *ngIf="statusBadge(item) as b" class="status-badge" [ngClass]="b.tone">
                <i class="pi pi-info-circle"></i> {{ b.label }}
              </span>
            </div>
          </td>
          <td>
            <div class="cell-customer" [pTooltip]="customerTooltip(item)" tooltipPosition="top">
              <span class="customer-names">{{ customerSummary(item) || '—' }}</span>
            </div>
          </td>
          <td>
            <span class="product-name">{{ item.productName || '—' }}</span>
          </td>
          <td style="text-align: right">
            {{ item.computedTotal | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" style="text-align: center; padding: 24px">
            Nenhum item nesta categoria.
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>

    <ng-template pTemplate="footer">
      <button pButton type="button" class="easymarine primary"
        icon="pi pi-check" label="Concluir" (click)="closePersonalize()"></button>
    </ng-template>
  </p-dialog>
</div>
